import React, { useEffect, useState } from "react";
import { Container, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import TopHeader from "../Common/TopHeader";
import { Link, useLocation, useNavigate } from "react-router-dom";
import './Kiosk.css';
import { GetApiMethod, PostApiMethod, PutApiMethod } from "../../core/services/apiService";
import constant from "../../core/constant";
import { ActivateDeactivate, GetTenantId, restrictIntialSpace, textValidator, Checkeligibility, DisplayToaster, DisplayErrorMessages } from "../../core/services/sharedService";
import AppModal from "../AppModal/AppModal";

const CreateKiosk = () => {
    const locations = useLocation();

    Checkeligibility(constant.KIOSK_EDIT, locations, constant.KIOSK_LIST);

    const { register, handleSubmit, formState: { errors }, setError } = useForm<any>();
    const [disable, setDisable] = useState(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [locationdata, setLocationData] = useState("");
    const buttonname: any = (locations.state !== null) ? "Update" : "Submit";
    const headername: any = (locations.state !== null) ? "Edit Kiosk - " + locations.state?.name : "Create Kiosk";
    const locationUrl = "tenant/location-crud";
    const kioskurl = "tenant/kiosk-crud";
    const navigate = useNavigate();

    const [showPopUp, setShowPopUp] = useState(false);
    const [showUnlinkPopUp, setShowUnlinkPopUp] = useState(false);

    const [checkStatus, setCheckStatus] = useState(locations.state?.status);

    useEffect(() => {
        GetApiMethod(locationUrl).then((res) => {
            const ActiveLocations = res.data.data.filter((items: any) => (items.isActive))
            setLocationData(ActiveLocations);
        });
    }, []);

    const handleToggle = (e: any) => {
        console.log(e.target.checked);
        setCheckStatus(e.target.checked);
    }

    const pageDisable = () => {
        setDisable(true);
        setLoading(true);
        document.body.classList.add('screen-disable');
    }

    const pageEnable = () => {
        setDisable(false);
        setLoading(false);
        document.body.classList.remove('screen-disable');
    }

    const handleRegistration = (data: any) => {
        let mydata: any = new Object(data);

        mydata['activated'] = checkStatus;
        mydata['name'] = data.name.trim();

        const payloadValue = [{ value: data.name, minLength: 4, maxLength: 40, key: 'name' }];
        const validation = textValidator(payloadValue);
        if (validation && validation.validation === true && validation.error) {
            validation.error.forEach(errorCase => {
                setError(errorCase.key, { type: errorCase.type });
            });
            return false;
        }

        if ((locations.state === null)) {
            pageDisable();
            PostApiMethod(kioskurl, data).then((res: any) => {
                console.log(res);
                if (res.data.status === "Success") {
                    pageEnable();
                    navigate(constant.KIOSK_LIST);
                    DisplayToaster("bg-success", "Kiosk " + data.name + " created successfully");
                }
            }).catch((err: any) => {
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!");
                pageEnable();
            })
        } else {
            pageDisable();
            PutApiMethod(`${kioskurl}/${locations.state.id}`, data).then((res: any) => {
                console.log(res);
                if (res.data.status === "Success") {
                    pageEnable();
                    navigate(constant.KIOSK_LIST);
                    DisplayToaster("bg-success", "Kiosk " + data.name + " updated successfully");
                }
            }).catch((err: any) => {
                DisplayToaster("bg-danger", DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!")
                pageEnable();
            })
        }
    };

    const [copySuccess, setCopySuccess] = useState('');
    const copyme = (copyText: any) => {
        let textField = document.createElement('textarea');
        textField.innerText = copyText;
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove();
        if (copyText === GetTenantId()) {
            setCopySuccess("1");
            DisplayToaster("bg-success", "Customer ID copied to clipboard!");
        } else {
            setCopySuccess("2");
            DisplayToaster("bg-success", "Kiosk ID copied to clipboard!");
        }
    }

    return (
        <>
            <Container fluid className="conatiner mt-3">
                <TopHeader disable={disable} heading={headername} to={constant.KIOSK_LIST} action="List" className="bi bi-list-ul" id="kiosk-list" />
                {
                    showPopUp &&
                    (
                        <AppModal
                            title={showUnlinkPopUp ? "Confirm To Unlink Kiosk!" : `Confirm To ${locations.state.is_active ? "Deactivate" : "Activate"}!`}
                            bodyText={showUnlinkPopUp ? `Are you sure you want to permanently unlink this kiosk? (The data on the kiosk will all be lost.)` :
                                `Are you sure you want to ${locations.state.is_active ? "deactivate" : "activate"} this kiosk?`
                            }
                            primaryButtonLabel={"Yes"}
                            secondaryButtonLabel={"No"}
                            primaryButtonEventEmitter={() => { ActivateDeactivate("Kiosk", locations.state.name, kioskurl, locations.state.id, locations.state.is_active, () => { navigate(constant.KIOSK_LIST) }, (showUnlinkPopUp ? true : false)); setShowPopUp(false); setShowUnlinkPopUp(false) }
                            }
                            secondaryButtonEventEmitter={() => { setShowPopUp(false); setShowUnlinkPopUp(false) }}
                        />
                    )
                }
                <Form onSubmit={handleSubmit(handleRegistration)} >

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Name <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <input type="text" defaultValue={locations.state?.name} onKeyDown={(e) => { restrictIntialSpace(e) }} className="form-control" {...register('name', { required: true, minLength: 4, maxLength: 40 })} />
                            {errors.name?.type === "required" && <small className='text-danger' >Name is required</small>}
                            {errors.name?.type === "minLength" && <small className='text-danger' >Minimum 4 characters is required</small>}
                            {errors.name?.type === "maxLength" && <small className='text-danger' >Maximum 40 characters only allowed</small>}
                        </div>
                    </div>

                    <div className='row mb-2'>
                        <div className='col-md-4'>
                            <label>Location <span className='text-danger'>*</span></label>
                        </div>
                        <div className='col-md-4'>
                            <select className="form-select" defaultValue={locations.state?.location_name} {...register('location', { required: true })}>
                                {(locations.state?.location_name ? null : <option value="">Select</option>)}

                                <option value={locations.state?.location_id} hidden>
                                    {locations.state?.location_name}
                                </option>

                                {Object.values(locationdata).map((items: any, i: number) => {

                                    return <option key={items._id} value={items._id}>{items.name}</option>
                                })}
                            </select>
                            {errors.location && <small className='text-danger' >Location is required</small>}
                        </div>
                    </div>

                    {
                        locations?.state !== null ?
                            <div className='row mb-2'>
                                <div className='col-md-4'>
                                    <label>Status </label>
                                </div>
                                <div className='col-md-4'>
                                    <input type="text" className="form-control" disabled value={locations.state.is_active ? "Active" : "Inactive"} />
                                </div>
                            </div> : ""
                    }

                    {
                        locations?.state !== null ? <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Kiosk ID <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-2 mb-2'>
                                <input type="text" defaultValue={locations?.state.id} disabled className="form-control" />
                            </div>
                            <div className='col-md-2'>
                                <span className="btn btn-outline-primary" onClick={(e) => { copyme(locations?.state.id) }}>{(copySuccess === "2") ? "Copied !!!" : <i className="bi bi-clipboard2-plus-fill" aria-hidden="true"> Copy Me</i>}</span>
                            </div>
                        </div> : ""
                    }

                    {
                        locations?.state !== null ? <div className='row mb-2'>
                            <div className='col-md-4'>
                                <label>Customer ID <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-md-2 mb-2'>
                                <input type="text" defaultValue={GetTenantId()} disabled className="form-control" />
                            </div>

                            <div className='col-md-2'>
                                <span className="btn btn-outline-primary" onClick={(e) => { copyme(GetTenantId()) }}>{(copySuccess === "1") ? "Copied !!!" : <i className="bi bi-clipboard2-plus-fill" aria-hidden="true"> Copy Me</i>}</span>
                            </div>
                        </div> : ""
                    }

                    <div className='text-center'>
                        <button type="submit" disabled={disable} className='btn btn-primary app-button-color mr-2'>{isLoading && <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>} {buttonname}</button>
                        {locations?.state && <button type="button" className={locations.state.is_active ? "btn btn-danger mr-2" : "btn btn-success mr-2"} onClick={(e) => { setShowPopUp(true) }} > {locations.state.is_active ? "Deactivate" : "Activate"} </button>}
                        {locations?.state && <button type="button" className={locations.state.status ? "btn btn-danger mr-2" : "d-none btn btn-success mr-2"} onClick={(e) => { setShowUnlinkPopUp(true); setShowPopUp(true) }} > Unlink </button>}
                        {disable ? <Link to={constant.KIOSK_LIST} className="disabledCursor" onClick={(event) => event.preventDefault()}><button type="reset" disabled={disable} className='btn btn-secondary'>Cancel</button></Link> : <Link to={constant.KIOSK_LIST}><button type="reset" className='btn btn-secondary'>Cancel</button></Link>}
                    </div>
                </Form>
            </Container>
        </>
    )
}

export default CreateKiosk;